export interface IGridColumnSizing {
  minWidth: number;
  width?: number;
  flex?: number;
}

export const buildGridTemplateColumns = (
  columns: IGridColumnSizing[]
): string =>
  columns
    .map(({ minWidth, width, flex }) =>
      typeof width === "number"
        ? `${width}px`
        : `minmax(${minWidth}px, ${flex ?? 1}fr)`
    )
    .join(" ");
